// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-64fc5335]{min-width:350px}.wrapper.fullscreen[data-v-64fc5335]{min-width:150px;max-width:calc(90vw - 6rem)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
